import * as React from 'react';
import styled from 'styled-components';
import { ProductContent } from '../common/ProductContent';
import { PRODUCT_PROMO_BANNER } from '../../constants/DataTestIdAttributes';

export interface IProductPromoBannerProps {
    nid: number;
}

const ProductPromoBannerWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const ProductPromoBanner = (props: IProductPromoBannerProps) => (
    <ProductPromoBannerWrapper
        className={'elc-product-promo-banner-wrapper'}
        data-test-id={PRODUCT_PROMO_BANNER}
    >
        <ProductContent nid={props.nid} />
    </ProductPromoBannerWrapper>
);
